import React, { useState, useEffect } from 'react';
import WelcomeForm from '../Partial_Forms/WelcomeForm';
import PartialDemographicForm from '../Partial_Forms/PartialDemographicForm';
import SelectCitiesForm from '../Partial_Forms/SelectCitiesForm';
import SelectVisitedPOIsForm from '../Partial_Forms/SelectVisitedPOIsForm';
import RateVisitedPOIsForm from '../Partial_Forms/RateVisitedPOIsForm';
import ThanksPage from '../Other_pages/ThanksPage';

import POITypeForm from '../Forms/POITypeForm';
import { fetchCountries, fetchCities, fetchPoisByCity, createUser, submitSurveyData } from '../api/api';

import loadingGif from '../assets/loading3.gif';


const PartialApp = ({language}) => {
  const [currentPage, setCurrentPage] = useState('welcome');
  const [formData, setFormData] = useState('');
  const [countries, setCountries] = useState([]);
  const [cityOptions, setCityOptions] = useState([]);
  const [currentCity, setCurrentCity] = useState(0);
  const [visitedCities, setVisitedCities] = useState([]);
  const [citiesPois, setCitiesPois] = useState([]);

  const [currentCityVisitedPOIs, setCurrentCityVisitedPOIs] = useState([])

  const [POIRatings, setPOIRatings] = useState([])
  const [userId, setUserId] = useState(0);
  const excluded_cities = [3, 4, 5, 6, 7, 8, 9, 10, 11, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22]

  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [currentPage]);

  const handleWelcomeSubmit = () => {
    setCurrentPage('demographics');
    const loadCountries = async () => {
      setIsLoading(true); 
      const countriesData = await fetchCountries();
      if (countriesData) setCountries(countriesData);
      setIsLoading(false); 
    };
    loadCountries();
    console.log(currentPage);
  };

  const handleDemographicSubmit = (data) => {
    setFormData(data);
    setCurrentPage('poitypeform');
  };

  const handlePOITypeSubmit = async (data) => {
    setFormData(data);
    const userId = await createUser(data, false);
    console.log(userId)
    setUserId(userId.user_id);

    const citiesData = await fetchCities();
    if (citiesData) {
      setCityOptions(citiesData.filter((city) => !excluded_cities.includes(city["city_id"])));
    }
    setCurrentPage('selectcities');
  };

  const handleSelectCitiesSubmit = async (data) => {
    const selected = data.cities; // [{ value: city_id, name: ... }]
    setVisitedCities(selected);
    setCurrentCity(0);
  
    const firstCityId = selected[0].value;
  
    const firstPOIs = await fetchPoisByCity(firstCityId);
    setCitiesPois((prev) => ({ ...prev, [firstCityId]: firstPOIs }));
  
    selected.slice(1).forEach((city) => {
      console.log("Fetching POIs for city:", city.value);
      fetchPoisByCity(city.value).then((pois) => {
        setCitiesPois((prev) => ({ ...prev, [city.value]: pois }));
      });
    });
  
    setCurrentPage('selectvisitedpois');
  };
  

  const handleSelectVisitedPOIsSubmit = (visitedPOIs) => {
    setCurrentCityVisitedPOIs(visitedPOIs)
    setCurrentPage('ratevisitedpois');
  };

  const handleRateVisitedPOIsSubmit = (ratedVisitedPOIs) => {
    setPOIRatings(prev => [...prev, ...ratedVisitedPOIs]);
    const nextCity = currentCity + 1;
    setCurrentCity(nextCity);
    submitSurveyData(userId, [...ratedVisitedPOIs])
    if (nextCity < visitedCities.length) {
      setCurrentPage('selectvisitedpois');
    } else {
      setCurrentPage('thanks');
    }
  };


  return (
    <>
      {isLoading ? (
        <div className="loading-spinner">
          <img src={loadingGif} />
          <p>Loading</p>
        </div>
      ) : (
        <>
          {currentPage === 'welcome' && <WelcomeForm language={language} onNavigate={handleWelcomeSubmit} />}
          {currentPage === 'demographics' && <PartialDemographicForm countries={countries} language={language} onNavigate={handleDemographicSubmit} />}
          {currentPage === 'poitypeform' && <POITypeForm formData={formData} language={language} onNavigate={handlePOITypeSubmit} />}
          {currentPage === 'selectcities' && <SelectCitiesForm formData={formData} cities={cityOptions} language={language} onNavigate={handleSelectCitiesSubmit} />}
          {currentPage === 'selectvisitedpois' && <SelectVisitedPOIsForm currentCity={visitedCities[currentCity]} pois={citiesPois} language={language} onNavigate={handleSelectVisitedPOIsSubmit} />}
          {currentPage === 'ratevisitedpois' && <RateVisitedPOIsForm currentCity={visitedCities[currentCity]} pois={currentCityVisitedPOIs} language={language} onNavigate={handleRateVisitedPOIsSubmit} />}
          {currentPage === 'thanks' && <ThanksPage language={language} name={formData["name"]?.split(" ")[0]} />}
        </>
      )}
    </>
  );  
};

export default PartialApp;
